import './AppListItem.less';
import { SvgIcon } from '@/components';
import { AppInfo } from '@/shared';

export interface AppListItemProp {
  data: AppInfo;
}

export function AppListItem(
  props: AppListItemProp & React.HTMLAttributes<HTMLDivElement>,
) {
  const { data, className, ...otherProps } = props;
  return (
    <div className="app-list-item" {...otherProps}>
      <img className="app-list-item__icon" src={data.icon} alt="" />
      <div className="app-list-item__info">
        <p className="app-list-item__appname">{data.appName}</p>
        <p className="app-list-item__pkgname">
          {window.trans('pkg-name')}: {data.pkgName}
        </p>
      </div>
      <div className="app-list-item__oper">
        <span>{window.trans('manage-widget')}</span>
        <SvgIcon name="collapse" />
      </div>
    </div>
  );
}
